// extracted by mini-css-extract-plugin
export default {"container":"SeriesCard_container__GXZ7m","info":"SeriesCard_info__Kt4cE","infoLeft":"SeriesCard_infoLeft__uVi2f","link":"SeriesCard_link__0noIu","name":"SeriesCard_name__OhNj-"};